import {DependencyList} from 'react';
import {useStyles} from '../../shared/hooks/styles';
import {AlignFunc} from '../../shared/theme/helpers';
import {Theme} from '../../shared/theme/interface';

const paperBorderRadius = 24;

export const GetStyles = (align: AlignFunc, theme: Theme, containerWidth: number, deps?: DependencyList) => {
  return useStyles(
    ({addShadow}) => ({
      barcodeWrapper: {
        overflow: 'hidden',
        ...addShadow({
          height: 2,
          radius: 18,
          opacity: 0.25,
        }),
        borderRadius: align(paperBorderRadius),
        marginBottom: align(30),
        width: containerWidth,
      },
      cardNumberTitle: {
        ...theme.fonts.label,
        color: theme.color.gray500,
        marginBottom: 4,
      },
      cardNumberContainer: {
        overflow: 'hidden',
        ...addShadow({
          height: 2,
          radius: 18,
          opacity: 0.1,
        }),
        height: 70,
        backgroundColor: theme.color.primaryNonGreyBackground,
        width: containerWidth,
        paddingVertical: 14,
        justifyContent: 'center',
        paddingHorizontal: 16,
        borderRadius: align(paperBorderRadius),
      },
      cardNumberText: {
        ...theme.fonts.h5,
        fontSize: Math.min(23, Number(theme.fonts.h5.fontSize)),
        lineHeight: Math.min(26, Number(theme.fonts.h5.lineHeight)),
        color: theme.color.textColor,
      },
      screen: {flex: 1},
      scroll: {flex: 1},
      container: {
        maxHeight: '100%',
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        backgroundColor: theme.color.white,
        overflow: 'hidden',
      },
      innerContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 32,
      },
      barcode: {
        paddingBottom: align(30),
      },
      modal: {
        justifyContent: 'flex-end',
        margin: 0,
      },
      closeButton: {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 10,
        marginBottom: 17,
      },
    }),
    deps,
  );
};
